module.exports = __webpack_public_path__ + "static/img/Fred Saayman.62739d03.png";